import SectionHeader from "@/components/base/SectionHeader";

const reasons = [
  {
    icon: "ri-focus-3-line",
    title: "Business First",
    desc: "We start with the problem, not the technology.",
  },
  {
    icon: "ri-settings-3-line",
    title: "Practical Technology",
    desc: "We build solutions that are useful, maintainable and designed for real-world use.",
  },
  {
    icon: "ri-team-line",
    title: "One Technology Partner",
    desc: "From websites to custom applications, automation and ongoing improvement.",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "Built for Growth",
    desc: "Our solutions are designed with scalability and future expansion in mind.",
  },
];

export default function WhyEmchon() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeader
          align="center"
          eyebrow="Why EMCHON"
          title="Why Organizations Choose EMCHON"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="rounded-lg border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${r.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {r.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {r.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}